if (!customElements.get("search-drawer")) {
  customElements.define(
    "search-drawer",
    class SearchDrawer extends Drawer {
      constructor() {
        super();
        this.recommendationByHistory = this.querySelector("recommendation-by-history");
      }

      show(opener) {
        super.show(opener);
        if (this.recommendationByHistory) {
          this.recommendationByHistory.showContent();
        }
        // Focus the search field after the modal trap settles so mobile
        // shoppers can type immediately without hunting for a tiny input.
        const input = this.querySelector('input[type="search"]');
        if (!input) return;
        requestAnimationFrame(() => {
          setTimeout(() => {
            try {
              input.focus({ preventScroll: true });
            } catch (e) {
              input.focus();
            }
          }, 60);
        });
      }

      hide() {
        super.hide();
        if (this.recommendationByHistory) {
          this.recommendationByHistory.abortFetch();
        }
      }
    },
  );
}
